import { connect } from "react-redux";
import HotoSiteEngineerListing from "./hotoSiteEngineerListing";
import { bindActionCreators } from "redux";
import { getGOLiveFilterDropDown } from "services/redux/maintenance/goLiveSite/action";
import { fetchHotoEngList } from "services/redux/maintenance/hoto/action";
import HotoReducer from "../../../services/redux/maintenance/hoto/reducer";

const mapStateToProps = (state) => ({
  hotoSiteData: state.HotoReducer.hotoEngSiteData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchHotoEngList,
      getGOLiveFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoSiteEngineerListing);
